import { useEffect } from 'react';

import { useTranslation } from 'react-i18next';

export const useSyncHtmlLang = () => {
  const { i18n } = useTranslation();

  useEffect(() => {
    const lang = i18n.resolvedLanguage || i18n.language; // e.g. "en", "en-GB", "ka"
    document.documentElement.lang = lang;

    // Optional but recommended (especially for RTL languages)
    document.documentElement.dir = i18n.dir(lang); // "ltr" or "rtl"
  }, [i18n, i18n.language, i18n.resolvedLanguage]);
};
